// extracted by mini-css-extract-plugin
export default {"stars":"star-rating_stars__65isQ"};